import { Injectable } from "@angular/core";
import { PruHttpService } from "./pru-http.service";
import { Observable, Subject, ReplaySubject } from 'rxjs';
import { shareReplay, tap } from "rxjs/operators";
import { GenericService } from "./generic.service";

@Injectable({
  providedIn: "root"
})
export class RetirementService {
  static readonly NO_RETIREMENT_VALUE: number = 0;

  public retirementDataSubject: ReplaySubject<any> = new ReplaySubject();
  public retirementObs = this.retirementDataSubject.asObservable();
  public retirementData$: any = null;
  public retBalance: any = 0;

  constructor(
    private _pruHttp: PruHttpService,
    private _genericService: GenericService
  ) { }
  getRetirementData$() {
    /* standard hearder for ret services */
    const customHeaders = { 'X-PruBU-RET-ApplicationKey': 'WEB', 'X-PruBU-RET-UserType': this._genericService.usr_csr ? 'I' : 'P'};
    const retUrl = "/api/co/secure/myaccounts/v2/accountsummary";
    if (!this.retirementData$) {
      this.retirementData$ = this._pruHttp.get(retUrl, "retirement", { "buName": 'Retirement', "clearcache": this._genericService.xPruId }, customHeaders)
        .pipe(
          tap(retData => {
            if (retData && retData["contractSummaryResponse"] && retData["contractSummaryResponse"].contractSummary && retData["contractSummaryResponse"].contractSummary.length > 0) {
              if (retData["contractSummaryResponse"].contractSummary.length == 1 && retData["contractSummaryResponse"].contractSummary[0]["accountActions"]) {
                let contributionUrl = retData["contractSummaryResponse"]["contractSummary"][0]["accountActions"].filter((item) => /Change Contributions/i.test(item.actionTitle));
                this._genericService.retCntrUrl = contributionUrl[0]? contributionUrl[0]["actionTarget"]:"";
              }
              retData["contractSummaryResponse"].contractSummary.forEach(contract => {
                if (contract.primaryContractValue && /amount/i.test(contract.primaryContractValue.valueType) && contract.primaryContractValue.contributesTo) {
                  this.retBalance += parseFloat(contract.primaryContractValue.value);
                }
                if (contract.secondaryContractValues && contract.secondaryContractValues.length > 0) {
                  contract.secondaryContractValues.forEach(secVal => {
                    if (secVal && secVal["group"]) {
                      secVal["group"].forEach(secGpVal => {
                        if (/amount/i.test(secGpVal.valueType) && secGpVal.contributesTo) {
                          this.retBalance += parseFloat(secGpVal.value);
                        }
                      });
                    }
                  });
                }
              });
              this.retirementDataSubject.next(this.retBalance);
            }
          }),
          shareReplay()
        );
    }
    return this.retirementData$;
  }

  hasRetirementBalance() {
    return this.retBalance > RetirementService.NO_RETIREMENT_VALUE;
  }
}